// extracted by mini-css-extract-plugin
export default {"backdrop":"AddNewFile_backdrop__-oShQ","z_index_100":"AddNewFile_z_index_100__4LzCm","modal_title":"AddNewFile_modal_title__7r4sw","BlogIcon":"AddNewFile_BlogIcon__3Nksi"};